import { Component } from '@angular/core';
import { CommonModule, NgOptimizedImage, } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalSwipeDirective } from '../../../shared/directives/modal-swipe/modal-swipe.directive';
import { OverlaySwipeDirective } from '../../../shared/directives/modal-swipe/overlay-swipe.directive';
import { BottomSwipeSheetDirective } from '../../../shared/directives/modal-swipe/bottom-swipe-sheet.directive';
import { CounterComponent } from '../../../shared/components/counter/counter.component';
import { CurrencyComponent } from '../../../shared/components/price/currency.component';
import { UIMenuItemDto } from '../../../shared/interfaces/ui-menu-item-dto.interface';
import { Observable, tap } from 'rxjs';
import { MenuItemSizeDto } from '../../../api/v1/models/menu-item-size-dto';
import { FreshPortionListComponent } from '../components/fresh-portion-list/fresh-portion-list.component';
import { FreshSizePickerComponent } from '../components/fresh-size-picker/fresh-size-picker.component';
import { ModifierListModule } from '../../../components/modifier-list/modifier-list.module';
import { ProductUnitComponent } from '../../../blocks/product-unit/product-unit.component';
import { ProductPriceComponent } from '../../../blocks/product-price/product-price.component';
import { RelatedCardComponent } from '../../../components/related-card/related-card.component';
import { PictureFallbackDirective } from '../../../shared/directives/picture-fallback/picture-fallback.directive';
import { ProductInfoPageAbstract } from '../../common/product-info-page.abstract';

@Component({
  selector: 'app-fresh-product-info-page',
  templateUrl: './fresh-product-info-page.component.html',
  styleUrls: ['./fresh-product-info-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    NgOptimizedImage,
    ReactiveFormsModule,
    ModalSwipeDirective,
    OverlaySwipeDirective,
    BottomSwipeSheetDirective,
    CounterComponent,
    CurrencyComponent,
    FreshPortionListComponent,
    FreshSizePickerComponent,
    ModifierListModule,
    ProductUnitComponent,
    ProductPriceComponent,
    RelatedCardComponent,
    PictureFallbackDirective,
  ]
})
export class FreshProductInfoPageComponent extends ProductInfoPageAbstract {

  relatedProducts$: Observable<UIMenuItemDto[]>;

  override ngOnInit(): void {
    super.ngOnInit();
    this.data$ = this.data$.pipe(
      tap(() => {
        if (this.currentSize) {
          this.relatedProducts$ = this.menuListRepository.getRelatedProducts(this.currentSize.relatedProducts)
        }
      })
    );
  }

  override onChangeSize(size: MenuItemSizeDto): void {
    super.onChangeSize(size);
    this.relatedProducts$ = this.menuListRepository.getRelatedProducts(this.currentSize.relatedProducts);
  }
}
